import agencyDashboardAPI from '@/utils/api/agencyDashboard';
import { genericError, genericSuccess } from '@/utils/alerts.service';

export const actions = {
  async fetchAgencyProfileInformation({ commit, dispatch }) {
    return agencyDashboardAPI
      .getProfile()
      .then(data => {
        commit('setAgencyProfile', data);
      })
      .catch(() => {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      });
  },

  async fetchCategories({ commit, dispatch }) {
    return agencyDashboardAPI
      .getCategories()
      .then(data => {
        commit('setCategories', data.results);
      })
      .catch(() => {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      });
  },

  async fetchSettings({ commit, dispatch }) {
    return agencyDashboardAPI
      .getSettings()
      .then(data => {
        commit('setSettings', data);
      })
      .catch(() => {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      });
  },

  async saveProfile({ commit, dispatch, state }, promise) {
    if (promise) {
      return new Promise((resolve, reject) => {
        return agencyDashboardAPI
          .updateProfile({ ...state.agencyProfile })
          .then(() => {
            commit('addSaveProgress', null, { root: true });
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    } else {
      return agencyDashboardAPI
        .updateProfile({ ...state.agencyProfile })
        .then(() => {
          dispatch('showUserMessage', { ...genericSuccess }, { root: true });
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    }
  },

  updateLocation({ commit }, payload) {
    commit('updateLocation', payload);
  },
};
